import { render } from "./Comentarios.vue?vue&type=template&id=38986e09&scoped=true"
import script from "./Comentarios.vue?vue&type=script&lang=js"
export * from "./Comentarios.vue?vue&type=script&lang=js"

import "./Comentarios.vue?vue&type=style&index=0&id=38986e09&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38986e09"]])

export default __exports__